import {Badge} from "shards-react";
import React from "react";

export const PAID = "paid";
export const NOT_CAPTURED = "not captured";
export const PENDING = "pending";
export const REFUSED = "failed";
export const REFUNDED = "refunded";
export const SUCCEEDED = "succeeded";

export function getPaymentStatusName() {
    return [
        { value: PAID, label: 'Paid', color: '#32CD32' },
        { value: NOT_CAPTURED, label: 'Not captured', color: 'gray' },
        { value: PENDING, label: 'Pending', color: 'yellow' },
        { value: REFUSED, label: 'Failed', color: 'red' },
    ];
}

export const mapOwnStatusToApiStatus = (status) => {
    const mapping = {
        [PAID]: 'paid',
        [NOT_CAPTURED]: 'not_captured',
        [PENDING]: 'pending',
        [REFUSED]: 'refused',
        [REFUNDED]: 'refunded',
    }

    return mapping[status];
}

const mapChargeStatusToOwnStatus = (charge) => {
    if (charge.refunded) {
        return REFUNDED;
    }

    if (charge.status === SUCCEEDED && charge.captured === true) {
        return PAID;
    }

    if (charge.status === SUCCEEDED && charge.captured === false) {
        return NOT_CAPTURED;
    }

    if (charge.status === "failed") {
        return  REFUSED;
    }
}

export const getColorBy = (charge) => {
    const colorByPaymentStatus = {
        'paid' : '#32CD32',
        'not captured' : '#32CD32',
        'pending' : 'yellow',
        'failed' : 'red',
        'refunded' : 'orange',
    }

    return colorByPaymentStatus[mapChargeStatusToOwnStatus(charge)];
}

export const getPaymentStatusBadgeContent = (charge) => {
    const ownStatus = mapChargeStatusToOwnStatus(charge);

    if (ownStatus === PAID || ownStatus === NOT_CAPTURED) {
        return <span> { ownStatus } </span>
    }

    if (ownStatus === REFUNDED) {
        return REFUNDED;
    }

    if (ownStatus === REFUSED) {
        return (
            <div className = "container-tooltip">
                <span> { ownStatus } </span>
                <Badge pill className="tooltip">
                    { charge.failure_code }: <br/> { charge.failure_message }
                </Badge>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/SelectList/PaymentsStatus.js